import * as types from '../constants/actionTypes';


// example of a thunk using the redux-thunk middleware
export function addNotification(message, level) {
    return {
      type: types.ADD_NOTIFICATION,
      message,
      level
  };
}

